import React from 'react';
import { Buttons } from 'lidya-common-components';
import { Trans, useTranslation } from 'gatsby-plugin-react-i18next';
import { StaticImage } from 'gatsby-plugin-image';
import SignUpModal from '../../default/signUp/sign.up.modal';
import './open.less';
import { POSSIBLE_FORMS } from '../../default/signUp/sign.up.memo.form';

const CurrentlyOpen = function () {
  const { t } = useTranslation();

  return (
    <div className="o-investors">
      <div className="m-globalContentContainer">
        <div className="m-investors__container m-investors__centered">
          <div className="m-investors__banner --padding-right --padding-left">
            <span className="m-investors__image --aligned-items --left">
              <StaticImage
                src="../../../images/investments/history.svg"
                alt={t('images.history.alt')}
                title={t('images.history.title')}
                className="a-investors__banner_image_original"
                objectFit="contain"
                width={32}
                height={32}
              />
              <div>
                <Trans i18nKey="web.investors.open.currently" />
              </div>
            </span>
            <span className="m-investors__text --right">
              <SignUpModal
                id="Open"
                type={Buttons.BUTTON_TYPES.PRIMARY}
                signupType={POSSIBLE_FORMS.INVESTORS}
                label="web.investors.invest.button"
                onClick={() => toggleModal()}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentlyOpen;
